// QR login for the phone app, shared with it.
//
// Someone already signed in here shows a QR code; the app scans it and signs
// into the very same account, so nobody types an ESIS id and a birth date on
// a phone keyboard.
//
//   qrLogins/{sessionId}
//     status    "ready" → the app deletes the document once it is in
//     userPath  the account document: schools/{id}/teachers/{id}
//     name      who it is, so the phone can say it out loud
//     school
//     createdAt
//
// The id inside the QR is the only secret, so a session is used once and the
// document is deleted the moment the phone reads it. No password travels.

const fb = require("@/firebaseConfig.js");

export const QR_PREFIX = "bagshlogin:";

function randomId() {
  const bytes = new Uint8Array(24);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

function nameOf(userData) {
  const name = [userData.LAST_NAME, userData.FIRST_NAME]
    .filter((part) => !!part)
    .join(" ")
    .trim();
  return name || userData.DISPLAY_NAME || userData.USERNAME || "Хэрэглэгч";
}

/** Starts a session for this account and returns what the QR should say. */
export async function createSession(userData) {
  const id = randomId();

  await fb.db
    .collection("qrLogins")
    .doc(id)
    .set({
      status: "ready",
      userPath: userData.ref.path,
      name: nameOf(userData),
      school: (userData.school && userData.school.name) || "",
      createdAt: fb.firestore.FieldValue.serverTimestamp(),
    });

  return { id: id, code: QR_PREFIX + id };
}

/** The phone deletes the document as it signs in, which is the "done" signal. */
export function watchSession(id, onUsed) {
  return fb.db
    .collection("qrLogins")
    .doc(id)
    .onSnapshot(
      (snap) => {
        if (!snap.exists) onUsed();
      },
      () => {},
    );
}

export async function dropSession(id) {
  try {
    await fb.db.collection("qrLogins").doc(id).delete();
  } catch (e) {
    // Already gone.
  }
}
